<section class="featured">
  <div class="featured__inner">
    <header class="featured__header" appReveal>
      <p class="section-label" i18n="@@featured.eyebrow">精選推薦 Featured</p>
      <h2 class="featured__title font-display" i18n="@@featured.title">人氣產品</h2>
      <p class="featured__sub font-display" i18n="@@featured.subtitle">Hot Seller</p>
    </header>

    <div class="featured__grid" appReveal="100">
      <app-product-card
        *ngFor="let product of products; let i = index; trackBy: trackByProduct"
        [product]="product">
      </app-product-card>
    </div>

    <div class="featured__cta" appReveal="200">
      <a class="featured__view-all" href="#/products/40" i18n="@@featured.viewAll">瀏覽所有產品</a>
    </div>
  </div>
</section>
